<template>
	<Timeline
		v-if="isTimelineEnabled"
		:event="event"
		:mode="timelineMode"
		:elapsed="elapsed"
		:duration="duration"
		:participants="participants"
		:tags="tags"
		:tag="selectedTag"
		:edited-tag="editedTag"
		:is-looking-back="isLookingBack"
		:is-paused="isPaused"
		:is-tagging-tool="isTaggingTool"
		@cursor-drag-start="$emit('cursor-drag-start')"
		@cursor-drag-end="$emit('cursor-drag-end')"
		@request-tag-edit="handleRequestTagEdit"
	/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Timeline from '@components/timeline';

export default {
	name:       'TimelineBlock',
	components: { Timeline },
	props:      {
		duration: {
			type:    Number,
			default: 0,
		},
		elapsed: {
			type:    Number,
			default: 0,
		},
		tag: {
			type:    Object,
			default: null,
		},
		isLookingBack: {
			type:    Boolean,
			default: false,
		},
		isTaggingTool: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters({
			event:                'event/event',
			isTimelineEnabled:    'features/isTimelineEnabled',
			eventTags:            'event/tags',
			eventTaggingToolTags: 'timelineTags/activeTags',
			editedTag:            'eventTagEdit/timelineSelectedTag',
			isPaused:             'player/isPaused',

		}),
		participants() {
			if (!this.event || !this.event.participants) {
				return [];
			}

			return this.event.participants.map(e => {
				let name = 'unknown';
				if (e.participatable.club) {
					if (e.participatable.club.code) name = e.participatable.club.code;
					else if (e.participatable.club.name) name = e.participatable.club.name;
				}
				if (e.context === 'player') {
					const words = e.participatable.name.match(/\b(\w+)\b/g);
					const capitalizedWords = words.filter(word => word.length > 0 && word[0] === word[0].toUpperCase());
					const abbreviation = capitalizedWords.map(word => word[0]);
					name = `${abbreviation.slice(0, 3).join('.')}.`;
				}

				return {
					id:       e.participatable.id,
					name,
					original: e,
				};
			});
		},
		selectedTag() {
			if (!this.tag) {
				return null;
			}

			return { ...this.tag };
		},
		timelineMode() {
			if (!this.isTaggingTool) {
				return 'view';
			}
			if (this.editedTag && !this.editedTag.isOutsideVideo) {
				return 'edit';
			}
			return 'normal';
		},
		tags() {
			return (this.isTaggingTool ? this.eventTaggingToolTags : this.eventTags).map(e => {
				const time = e.timestamp;
				const participant = (e.participant && e.participant.id) || (e.team && e.team.id) || (e.player && e.player.id);
				return {
					id:    e.id,
					name:  e.name,
					image: e.imageUrl,
					participant,
					time,
					tag:   e,
				};
			});
		},

	},
	methods: {
		...mapActions({
			updateEventTag: 'event/updateEventTag',
			editEventTag:   'eventTagEdit/editEventTag',
		}),
		handleRequestTagEdit(tag) {
			this.editEventTag(tag);
		},

	},
};
</script>
